<template>
  <v-container class="mt-4 support-page">
    <div class="text-center my-6">
      <h3>
        {{
          $t(
            "support:general.welcome.heading",
            "Welcome to KIPA Help & Training section!",
            "Welcome message on support page"
          )
        }}
      </h3>
    </div>
    <AppTabsCustom v-model="tabSelected" class="mb-5">
      <v-tab
        class="bolded-text"
        data-test="athletes"
        href="#athletes"
        @click="historyTabClick"
      >
        {{
          $t(
            "support:athletes.ForAthletes.tab",
            "For athletes",
            "Heading for tab with videos for athletes"
          )
        }}
      </v-tab>
      <v-tab
        class="bolded-text"
        data-test="horseOwners"
        href="#horseOwners"
        @click="historyTabClick"
      >
        {{
          $t(
            "support:horseOwners.ForHorseOwners.tab",
            "For horse owners",
            "Heading for tab with videos for horse owners"
          )
        }}
      </v-tab>
      <v-tab
        class="bolded-text"
        data-test="showOrganisers"
        href="#showOrganisers"
        @click="historyTabClick"
      >
        {{
          $t(
            "support:organisers.ForOrganisers.tab",
            "For show organisers",
            "Heading for tab with videos for show organisers"
          )
        }}
      </v-tab>
      <v-tab
        class="bolded-text"
        data-test="officials"
        href="#officials"
        @click="historyTabClick"
      >
        {{
          $t(
            "support:officials.ForOfficials.tab",
            "For officials",
            "Heading for tab with videos for officials"
          )
        }}
      </v-tab>
      <v-tab
        class="bolded-text"
        data-test="helpDocs"
        href="#helpDocs"
        @click="historyTabClick"
      >
        {{
          $t(
            "support:faqs.Faqs.tab",
            "FAQ-s",
            "Heading for tab with questions and answers"
          )
        }}
      </v-tab>
    </AppTabsCustom>
    <v-tabs-items v-model="tabSelected" touchless>
      <v-tab-item value="athletes">
        <v-row dense justify="center">
          <template v-for="(x, i) in forAthlete">
            <v-col
              :key="i"
              cols="12"
              sm="6"
              md="4"
              style="display: flex; flex-direction: column;"
            >
              <AppCard
                :data="x"
                class="ma-auto mb-3"
                no-cut
                :open-dialog="$vuetify.breakpoint.lgAndUp"
                :open-new-tab="$vuetify.breakpoint.mdAndDown"
                disable-title-hide
                :link-btn-text="$t('common:watchVideo.button', 'Watch video')"
                aria-haspopup
                @click="videoShowcase = $event"
              />
            </v-col>
            <v-col
              v-if="showBannerAdvertisement(i)"
              :key="i + 'banner'"
              cols="12"
            >
              <AppShowBanners placement-name="SUPPORT" />
            </v-col>
          </template>
        </v-row>
      </v-tab-item>
      <v-tab-item value="horseOwners">
        <v-row dense justify="center">
          <template v-for="(x, i) in forHorseOwners">
            <v-col
              :key="i"
              cols="12"
              sm="6"
              md="4"
              style="display: flex; flex-direction: column;"
            >
              <AppCard
                :data="x"
                class="ma-auto mb-3"
                no-cut
                disable-title-hide
                :open-dialog="$vuetify.breakpoint.lgAndUp"
                :open-new-tab="$vuetify.breakpoint.mdAndDown"
                :link-btn-text="$t('common:watchVideo.button', 'Watch video')"
                aria-haspopup
                @click="videoShowcase = $event"
              />
            </v-col>
            <v-col
              v-if="showBannerAdvertisement(i)"
              :key="i + 'banner'"
              cols="12"
            >
              <AppShowBanners placement-name="SUPPORT" />
            </v-col>
          </template>
        </v-row>
      </v-tab-item>
      <v-tab-item value="showOrganisers">
        <v-row dense justify="center">
          <template v-for="(x, i) in forOrganisers">
            <v-col
              :key="i"
              cols="12"
              sm="6"
              md="4"
              style="display: flex; flex-direction: column;"
            >
              <AppCard
                :data="x"
                class="ma-auto mb-3"
                no-cut
                disable-title-hide
                :open-dialog="$vuetify.breakpoint.lgAndUp"
                :open-new-tab="$vuetify.breakpoint.mdAndDown"
                :link-btn-text="$t('common:watchVideo.button', 'Watch video')"
                aria-haspopup
                @click="videoShowcase = $event"
              />
            </v-col>
            <v-col
              v-if="showBannerAdvertisement(i)"
              :key="i + 'banner'"
              cols="12"
            >
              <AppShowBanners placement-name="SUPPORT" />
            </v-col>
          </template>
        </v-row>
      </v-tab-item>
      <v-tab-item value="officials">
        <v-row dense justify="center">
          <template v-for="(x, i) in forOfficials">
            <v-col
              :key="i"
              cols="12"
              sm="6"
              md="4"
              style="display: flex; flex-direction: column;"
            >
              <AppCard
                :data="x"
                class="ma-auto mb-3"
                no-cut
                disable-title-hide
                :open-dialog="$vuetify.breakpoint.lgAndUp"
                :open-new-tab="$vuetify.breakpoint.mdAndDown"
                :link-btn-text="$t('common:watchVideo.button', 'Watch video')"
                aria-haspopup
                @click="videoShowcase = $event"
              />
            </v-col>
            <v-col
              v-if="showBannerAdvertisement(i)"
              :key="i + 'banner'"
              cols="12"
            >
              <AppShowBanners placement-name="SUPPORT" />
            </v-col>
          </template>
        </v-row>
      </v-tab-item>
      <v-tab-item value="helpDocs">
        <div>
          <v-btn
            href="https://kipa.helpscoutdocs.com"
            target="_blank"
            text
            color="primary"
          >
            {{ $t("support:documents.knowledgeBase.link") }}
            <v-icon class="mx-2" color="primary" small
              >$iconArrowOutSquare</v-icon
            >
          </v-btn>

          <iframe
            src="https://kipa.helpscoutdocs.com"
            title="Help Scout docs"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
    <AppShowBanners
      v-if="$vuetify.breakpoint.lgAndUp"
      placement-name="SUPPORT"
    />
    <AppVideoDialog
      :value="videoShowcaseBool"
      :video="videoShowcase"
      @hide="videoShowcase = false"
    />
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import AppCard from "@elements/AppCard.vue";
import AppTabsCustom from "@elements/AppTabsCustom.vue";
import AppVideoDialog from "@elements/AppVideoDialog.vue";
import { useTabHistory } from "@composables/tab_history";
import AppShowBanners from "@elements/banners/AppShowBanners.vue";
export default defineComponent({
  name: "AppSupport",
  components: {
    AppCard,
    AppTabsCustom,
    AppVideoDialog,
    AppShowBanners
  },
  setup() {
    const { tabSelected, historyTabClick } = useTabHistory("athletes");

    return { tabSelected, historyTabClick };
  },
  data() {
    return {
      videoShowcaseBool: false,
      videoObject: null
    };
  },
  computed: {
    videoShowcase: {
      get() {
        return this.videoObject;
      },
      set(val) {
        if (val == false) {
          this.videoObject = null;
          this.videoShowcaseBool = false;
        } else if (val && val.constructor === Object) {
          this.videoShowcaseBool = true;
          this.videoObject = val;
        }
      }
    },
    forAthlete() {
      return [
        {
          title: this.$t(
            "support:athletes.JoinSystem.title",
            "How do I join KIPA?",
            "How do I join KIPA? - title for join system video"
          ),
          description: this.$t(
            "support:athletes.JoinSystem.description",
            "Learn how to join KIPA system from out quick guide",
            "Learn how to join KIPA system from out quick guide - description for join system video"
          ),
          link: "https://vimeo.com/604608338/de7039d520"
        },
        {
          title: this.$t(
            "support:athletes.payLicence.title",
            "How to pay for licences in FIPA?",
            "How to pay for licences for athletes?"
          ),
          description: this.$t(
            "support:athletes.payLicence.description",
            "This short demo is about the licence shop and its functionalities.",
            "This short demo is about the licence shop and its functionalities."
          ),
          link: "https://vimeo.com/607226416/38de796235"
        },
        {
          title: this.$t(
            "support:athletes.findshow.title",
            "How to find a show in calendar?",
            "How to find a show in calendar?"
          ),
          description: this.$t(
            "support:athletes.findshow.description",
            "Watch this short video to help you use Calendar. Discover how to search for shows using Calendar filters",
            "Watch this short video to help you use Calendar. Discover how to search for shows using Calendar filters"
          ),
          link: "https://vimeo.com/607239245/6cee0c654f"
        },
        {
          title: this.$t(
            "support:athletes.RegisterToShow.title",
            "How to register, pay and change registration?",
            "How to register, pay and change registration?"
          ),
          description: this.$t(
            "support:athletes.RegisterToShow.description",
            "This is a quick guide to registration and payment process in KIPA. Learn how to manage your upcoming registrations and shopping basket",
            "Description of how to register and pay video"
          ),
          link: "https://vimeo.com/599464884/10b1b18e8a"
        },
        {
          title: this.$t(
            "support:athletes.RegisterToFEIShow.title",
            "How to make an entry to FEI event?",
            "How to make an entry to FEI event?"
          ),
          description: this.$t(
            "support:athletes.RegisterToFEIShow.description",
            "This is a detailed guide to your FEI entries. Learn how to find an FEI events and make an entry.",
            "Description of how to make an entry video"
          ),
          link: "https://vimeo.com/841818448/25e4d39851"
        },
        {
          title: this.$t(
            "support:athletes.deleteWithdrawFEIEntry.title",
            "How to delete or withdraw an FEI entry?",
            "How to delete or withdraw an FEI entry?"
          ),
          description: this.$t(
            "support:athletes.deleteWithdrawFEIEntry.description",
            "Learn how to delete or withdraw your emtry to FEI event",
            "Description of how to withdraw video"
          ),
          link: "https://vimeo.com/841818411/cf6a305035"
        },
        {
          title: this.$t(
            "support:athletes.changeFEIentryCategory.title",
            "How to change entry category in FEI show?",
            "How to change entry category in FEI show?"
          ),
          description: this.$t(
            "support:athletes.changeFEIentryCategory.description",
            "When competing at FEI level you might need to change a horse from one event to another at the same show. Learn how to do it as a self-service.",
            "Description of category change video"
          ),
          link: "https://vimeo.com/841818362/9cd4495d56"
        },
        {
          title: this.$t(
            "support:athletes.changeBeddingFEIEntry.title",
            "How to change bedding for FEI entry?",
            "How to change bedding for FEI entry?"
          ),
          description: this.$t(
            "support:athletes.changeBeddingFEIEntry.description",
            "Learn how to change bedding for your horse stabling box at FEI event",
            "Description of how to change bedding"
          ),
          link: "https://vimeo.com/841818501/358d5837f0"
        },
        {
          title: this.$t(
            "support:athletes.addNotesFEIEntry.title",
            "How to add and change notes for FEI entry?",
            "How to add and change notes for FEI entry?"
          ),
          description: this.$t(
            "support:athletes.addNotesFEIEntry.description",
            "Learn about adding notes to your FEI entry",
            "Description of how to add and edit notes"
          ),
          link: "https://vimeo.com/841818392/60dfbee762"
        },
        {
          title: this.$t(
            "support:athletes.addhorseToSlotFEIEntry.title",
            "How to add a horse to a horse slot for FEI Jumping entry?",
            "How to add a horse to a horse slot for FEI Jumping entry?"
          ),
          description: this.$t(
            "support:athletes.addhorseToSlotFEIEntry.description",
            "Learn about adding a horse to a horse slot in FEI Jumping entry",
            "Description of how to add horse to slot"
          ),
          link: "https://vimeo.com/841818474/b0f85a4dec"
        },
        {
          title: this.$t(
            "support:athletes.qualifications.title",
            "How to track your qualifications?",
            "How to track your qualifications?"
          ),
          description: this.$t(
            "support:athletes.qualifications.description",
            "Learn how KIPA tracks your qualifications and how organisers can check qualifications from Masterlist.",
            "Description qualifications video"
          ),
          link: "https://vimeo.com/607235179/63b3a2a363"
        },
        {
          title: this.$t(
            "support:athletes.AccountData.title",
            "Your account and data",
            "Your account and data - title"
          ),
          description: this.$t(
            "support:athletes.AccountData.description",
            "In this video we will explain the basic principles of how your personal account functions and how data is managed in the KIPA system",
            "Description of account and data video"
          ),
          link: "https://vimeo.com/607261816/8aaafa53bd"
        },
        {
          title: this.$t(
            "support:athletes.HorseLicence.title",
            "How to pay for my horse licence?",
            "How to pay for my horse licence? - title"
          ),
          description: this.$t(
            "support:athletes.HorseLicence.description",
            "In this short video we will explain how to pay for horse licences.",
            "Description of horse licences video"
          ),
          link: "https://vimeo.com/599464769/01e3082064"
        },
        {
          title: this.$t(
            "support:athletes.PonyMeasurements.title",
            "How to submit a pony measurements application?",
            "How to submit pony measurements application? - title"
          ),
          description: this.$t(
            "support:athletes.PonyMeasurements.description",
            "In this short video we will explain how to submit a pony measurements application",
            "Description of pony measurements video"
          ),
          link: "https://vimeo.com/607259320/253d74225a"
        }
      ].filter(i => i.link);
    },
    forHorseOwners() {
      return [
        {
          title: this.$t(
            "support:athletes.HorseLicence.title",
            "How to pay for my horse licence?",
            "How to pay for my horse licence? - title"
          ),
          description: this.$t(
            "support:athletes.HorseLicence.description",
            "In this short video we will explain how to pay for horse licences.",
            "Description of horse licences video"
          ),
          link: "https://vimeo.com/599464769/01e3082064"
        },
        {
          title: this.$t(
            "support:horseowners.HorseGroupLicence.title",
            "How to pay for my riding school horses' group licence?",
            "How to pay for my riding school horses' group licence? - title"
          ),
          description: this.$t(
            "support:horseowners.HorseGroupLicence.description",
            "In this short video we will explain how to pay for riding school horses' group licence. In new KIPA, riding schools� administrators can manage the list of horses themselves as a self-service.",
            "Description of horses' group licence video"
          ),
          link: "https://vimeo.com/607242261/748c4b503d"
        },
        {
          title: this.$t(
            "support:athletes.PonyMeasurements.title",
            "How to submit pony measurements application?",
            "How to submit pony measurements application? - title"
          ),
          description: this.$t(
            "support:athletes.PonyMeasurements.description",
            "In this short video we will explain how to submit a pony measurements application",
            "Description of pony measurements video"
          ),
          link: "https://vimeo.com/607259320/253d74225a"
        }
      ].filter(i => i.link);
    },
    forOrganisers() {
      return [
        {
          title: this.$t(
            "support:organisers.ProposeShow.title",
            "How do I add and propose show to Calendar?",
            "How do I add and propose show to Calendar?"
          ),
          description: this.$t(
            "support:organisers.ProposeShow.description",
            "This short video will help you to add and propose show to Calendar",
            "This short video will help you to add and propose show to Calendar - video description"
          ),
          link: "https://vimeo.com/599464974/cb7655c870"
        },
        {
          title: this.$t(
            "support:organisers.enablePayment.title",
            "How to enable payments?",
            "How to enable payments?"
          ),
          description: this.$t(
            "support:organisers.enablePayments.description",
            "This short video will guide you through the verification process to enable using payments in your shows or clinis",
            "This short video will guide you through the verification process to enable using payments in your shows or clinis"
          ),
          link: "https://vimeo.com/607281320/9d5ee56ff2"
        },
        {
          title: this.$t(
            "support:organisers.PayAndReportPrizes.title",
            "How to pay out prizes?",
            "How to pay out prizes video title"
          ),
          description: this.$t(
            "support:organisers.PayAndReportPrizes.description",
            "Watch this short video for update on how prizes are paid ut and reported",
            "How to pay out prizes? - video description"
          ),
          link: "https://vimeo.com/607230972/11835c30c5"
        },
        {
          title: this.$t(
            "support:organisers.ProposeSchedule.title",
            "How to add, edit and propose schedule?",
            "How to add, edit and propose schedule? - video title"
          ),
          description: this.$t(
            "support:organisers.ProposeSchedule.description",
            "Watch this short video to learn more on how to add, edit and propose schedule",
            "How to add, edit and propose schedule? - video description"
          ),
          link: "https://vimeo.com/594050600/fa15b227a0"
        },
        {
          title: this.$t(
            "support:organisers.ClubDiscounts.title",
            "How to add club discounts to a class?"
          ),
          description: this.$t(
            "support:organisers.ClubDiscounts.description",
            "This short video is about our new club discounts feature. Make sure your club members will benefit from it."
          ),
          link: "https://vimeo.com/604615083/d41e24cfac"
        },
        {
          title: this.$t(
            "support:organisers.CloneShow.title",
            "How to clone a show or a class?",
            "How to clone a show or a class? - video title"
          ),
          description: this.$t(
            "support:organisers.CloneShow.description",
            "In this video, you will learn about our new features - clone a show and clone a class.",
            "How to clone a show or a class? - video description"
          ),
          link: "https://vimeo.com/604612934/2477884e07"
        },
        {
          title: this.$t(
            "support:organisers.CancelShow.title",
            "How to cancel a show or a training?",
            "How to cancel a show or a trainings? - video title"
          ),
          description: this.$t(
            "support:organisers.CancelShow.description",
            "Watch this video if you need to cancel a show or a training",
            "How to cancel a show or a training? - video description"
          ),
          link: "https://vimeo.com/599473081/f54a130a88"
        },
        {
          title: this.$t(
            "support:organisers.masterlist.title",
            "How to manage Masterlist and manage entries",
            "How to manage Masterlist and manage entries - video title"
          ),
          description: this.$t(
            "support:organisers.masterlist.description",
            "Watch this video to learn about Masterlist functionalities. Check every detail before exporting entries to Equipe APP!",
            "How to manage Masterlist and manage entries - video description"
          ),
          link: "https://vimeo.com/607222834/d31d2643ca"
        },
        {
          title: this.$t(
            "support:organisers.lateentry.title",
            "How to add late entry to masterlist after registration is closed?"
          ),
          description: this.$t(
            "support:organisers.lateentry.description",
            "Watch this video to learn how to add a late entry in KIPA to your show masterlist."
          ),
          link: "https://vimeo.com/604610951/390efd79f3"
        },
        {
          title: this.$t(
            "support:organisers.ImportEntries.title",
            "How to import entries to Equipe APP and publish starting list?",
            "How to import entries to Equipe APP and publish starting list? - video title"
          ),
          description: this.$t(
            "support:organisers.ImportEntries.description",
            "Watch this short video to learn about importing entries to Equipe APP system. Equipe APP is a show management software that supports jumping, dressage, eventing and endurance and is fully integrated with KIPA.",
            "How to import entries to Equipe APP and publish starting list? - video description"
          ),
          link: "https://vimeo.com/594053357/27279bf0b2"
        },
        {
          title: this.$t(
            "support:organisers.PublishResults.title",
            "How to export, edit and publish results?",
            "How to export, edit and publish results? - video title"
          ),
          description: this.$t(
            "support:organisers.PublishResults.description",
            "In this video, we will demonstrate how to export results from Equipe APP or add results manually, how to edit and publish results.",
            "How to export, edit and publish results? - video description"
          ),
          link: "https://vimeo.com/594051842/23621897c3"
        },
        {
          title: this.$t(
            "support:organisers.IntroFinances.title",
            "Short intro to show finances",
            "How to manage show finances - title"
          ),
          description: this.$t(
            "support:organisers.IntroFinances.description",
            "Check this short video to learn about finances in show management.",
            "Short intro to show finances - video description"
          ),
          link: "https://vimeo.com/599546377/df7758031f"
        },
        {
          title: this.$t(
            "support:horseowners.HorseGroupLicence.title",
            "How to pay for my riding school horses' group licence?",
            "How to pay for my riding school horses' group licence? - title"
          ),
          description: this.$t(
            "support:horseowners.HorseGroupLicence.description",
            "In this short video we will explain how to pay for riding school horses' group licence. In new KIPA, riding schools� administrators can manage the list of horses themselves as a self-service.",
            "Description of horses' group licence video"
          ),
          link: "https://vimeo.com/607242261/748c4b503d"
        }
      ].filter(i => i.link);
    },
    forOfficials() {
      return [
        {
          title: this.$t(
            "support:officials.approveSchedule.title",
            "As a President of Ground Jury, how can I approve a schedule and open registration?",
            "As a President of Ground Jury, how can I approve a schedule and open registration? - video title"
          ),
          description: this.$t(
            "support:officials.approveSchedule.description",
            "In this short video, we will show you how to review, approve or decline a schedule of a club level show",
            "As a President of Ground Jury, how can I approve a schedule and open registration? - video description"
          ),
          link: ""
        }
      ].filter(i => i.link);
    }
  },
  methods: {
    showBannerAdvertisement(index) {
      index++;
      return this.$vuetify.breakpoint.mdAndDown && index % 3 === 0;
    }
  }
});
</script>
